import { createAction } from '@reduxjs/toolkit'

export const UpdateAsyncActionStatus = createAction<TopHap.GlobalState['status']>('global/update_async_action_status')
export const UpdateStates = createAction<Partial<TopHap.GlobalState>>('global/update_states')
